const mutations = {
  ALL_COUNTRIES (state, countries) {
    state.countries = countries
  },

  ALL_COMMUNICATION_METHODS (state, communication_methods) {
    state.communication_methods = communication_methods
  },

  ACCOUNT (state, account) {
    state.account = {...account}

    localStorage.setItem('currentAccount', JSON.stringify(account))
  },

  MEMBER_ACCOUNTS (state, accounts) {
    state.member_accounts = accounts
  },

  ACCEPTED_ACCOUNTS (state, accounts) {
    state.acceptedAccounts = accounts
  },

  SUB_ACCOUNT_INVITE_POPUP (state, payload) {
    state.popup = payload
  },
  ACCOUNT_MANAGERS (state, val) {
    state.managers = val
  },
  ACCOUNT_USERS (state, val) {
    state.accountUsers = val
  }
}

export default mutations
